export default __webpack_public_path__ + "static/media/Cavacas.d418bce5.jpg";